import Tooltip from '@material-ui/core/Tooltip'
import React from 'react'
import styled from 'styled-components'
import { StyledTypographyComponent } from '../AverageDepth/AvgDepthTextFieldList'
import Link from '@material-ui/core/Link'
import { Link as RouterLink } from 'react-router-dom'

interface ILinkProps {
  value: string
  onClick?: any
  fontSize?: string
  /**
   * NOTE: Specified type as any since row data will change depending upon entity for which
   * table is being rendered
   */
  node?: any
  disabled?: boolean
  to?: any
}

const Root = styled.div<{ disabled?: boolean }>(props => {
  return {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    ...(props.disabled ? { opacity: 0.5 } : null)
  }
})

export const StandardLink: React.FunctionComponent<ILinkProps> = React.memo(
  ({ value, onClick, fontSize, disabled, to }) => {
    return (
      <Root disabled={disabled}>
        <StyledTypographyComponent font={`Bold ${fontSize || '10px'}`}>
          <Tooltip title={value || ''}>
            {to ? (
              <RouterLink to={to}>{value}</RouterLink>
            ) : (
              <Link onClick={onClick}>{value}</Link>
            )}
          </Tooltip>
        </StyledTypographyComponent>
      </Root>
    )
  }
)
